/** LOCALSTORAGE KEYS */
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';

/** TABLE */
export const PAGE_SZIES = [10, 20, 30, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

/** API VERSION */
export const API_VERSION = 'v2.0';

/** API ENDPOINTS */
export const AUTH_ENDPOINTS = 'auth';
export const LOGIN = 'signIn';
export const REGISTER = 'signUp';
export const LOGOUT = 'signOut';

export const NOTES_ENDPOINTS = 'notes';

export const EMAIL_CONFIRM_TOKEN = 'token';
